/* import __COLOCATED_TEMPLATE__ from './category-title-before.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./category-title-before.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  tagName: ""
}));